import React,{ useEffect, useState, useReducer} from "react";

const Filters = (props)=>{

	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type) {
			case 'CHANGE':
				return { ...state, [action.k]:action.v };
            case 'ADD_TAG':
                return { ...state, selecteds:[...state.selecteds, action.selected] };
            case 'DELETE_TAG':
                return { ...state, selecteds:state.selecteds.filter((em) => (em.id != action.id)) };
			default:
				return state;
		}
	}, {
		started:false,
		tags:props?.tags || [],
        selecteds:[],
        elements:props?.elements || [],
        menu:props?.menu || [],
        results:[],
        filter:false,
        filter2:false,
        order:false,
        total:false,
        loading:false,
        search:props?.search || false,
        csearch:props?.csearch || '',
        asearch:props?.asearch || '',
	});

    const labels = props?.labels || {};
    const type_filter = props?.type || 'default';
    const is_filter_templates = type_filter == 'tpl';
    const is_filter_integrations = type_filter == 'integrations';
    const is_filter_ebooks = type_filter == 'ebooks';
    const is_filter_ideas = type_filter == 'ideas';
    const is_filter_success_cases = type_filter == 'cases';

    const changeSearch = (e) => {
        let element = e.target;
        dispatch({type:'CHANGE',k:'search',v:element.value});
    }

    useEffect(()=>{
        
        $('#search').on('change', (e) => {
            let element = e.target;
            dispatch({type:'CHANGE',k:'search',v:element.value});
        });

        if(is_filter_templates || is_filter_ebooks || is_filter_success_cases){
            $('#filter').selectric('refresh').on('change', (e) => {
                let element = e.target;
                let value_filter = element.value && element.value != '' ? element.value : false;
                dispatch({type:'CHANGE',k:'filter',v:value_filter});
            });
            if(is_filter_success_cases){
                $('#order').selectric('refresh').on('change', (e) => {
                    let element = e.target;
                    let value_order = element.value && element.value != '' ? element.value : false;
                    dispatch({type:'CHANGE',k:'order',v:value_order});
                });
            }
        }
    },[]);

    useEffect(()=>{
        if(is_filter_templates || is_filter_success_cases){
            if(state.filter != false){
                $('#filter2').removeAttr("disabled").on('change', (e) => {
                    let element = e.target;
                    dispatch({type:'CHANGE',k:'filter2',v:element.value});
                }).selectric('refresh');
            }else{
                $('#filter2').attr("disabled", "disabled").selectric('refresh');
            }
        }else if(is_filter_ebooks && state.filter != false){
            let selected = state.tags[state.filter];
            dispatch({type:'ADD_TAG',selected});
        }
    },[state.filter]);

    
    useEffect(()=>{
        if(throttleChange != undefined) clearInterval(throttleChange);
        let throttleChange = setTimeout(() => {
            search();
        }, 500);
    },[state.search,state.csearch,state.asearch]);

    useEffect(()=>{
        if(state.filter2 != false){
            let selected = state.tags[state.filter2];
            dispatch({type:'ADD_TAG',selected});
        }
    },[state.filter2]);

    useEffect(()=>{
        search();
    },[state.order]);

    useEffect(()=>{
        if(is_filter_templates || is_filter_ebooks || is_filter_success_cases){
            dispatch({type:'CHANGE',k:'filter',v:false});
            $('#filter').prop('selectedIndex', 0).selectric('refresh');
            if(is_filter_templates || is_filter_success_cases){
                dispatch({type:'CHANGE',k:'filter2',v:false});
                $('#filter2').prop('selectedIndex', 0).selectric('refresh');
            }
        }
        search();
    },[state.selecteds]);

    const match_tag = (tags) =>{
		var all = 0;
        $.each(state.selecteds,function(i,item){
            if(tags.indexOf(item.id)>-1){
                all++;
            }
        });
		return state.selecteds.length == all && state.selecteds.length > 0;
	}

    const convertObjectToArray = (obj) => {
        var arr = [];
        $.each(obj, (i, item) => {
            (typeof(item) == 'string') ? arr.push({ k:i, v:item }) : arr.push(Object.assign({}, { key:i }, item));
        });
    
        return arr;
    };
    

    const search = () => {
        dispatch({type:'CHANGE',k:'loading',v:true});
        let results = [];
		
        let word_search = state.search !== false ? state.search.toLowerCase() : false;
        word_search = word_search != '' && word_search.length > 0 ? word_search : state.search;
		
        let category_search = state.csearch.toLowerCase();
		category_search = category_search!='' && category_search.length > 0 ? category_search : false;
		
        let activity_search = state.asearch.toLowerCase();
        var re1 = new RegExp(' ', 'g');
        var re2 = new RegExp('%20', 'g');
		activity_search = activity_search!='' && activity_search.length > 0 ? activity_search.replace(re1,'').replace(re2,'') : false;
        const any_search = state.selecteds.length > 0 || word_search || category_search || activity_search;

        let no_filters = document.getElementById("no_filters");
        if(no_filters != undefined){
            if(state.order || any_search){
                no_filters.setAttribute('style', "display:none;");
            }else{
                no_filters.setAttribute('style', "display:inline;");
            }
        }
        
		if(any_search){
            let item_value_search = [];
            let item_value_csearch = [];
            if(is_filter_templates){
                item_value_search.push('nom');
                item_value_search.push('description');
                item_value_csearch.push('promo_type_name');
            }else if(is_filter_integrations){
                item_value_search.push('apartat_nom');
                item_value_search.push('apartat_resum');
            }else if(is_filter_ebooks){
                item_value_search.push('nom');
            }else if(is_filter_ideas){
                item_value_search.push('campanya');
                item_value_search.push('nom');
            }else if(is_filter_success_cases){
                item_value_search.push('nom');
                item_value_csearch.push('tagsname_search');
            }

            let _tags_activity = convertObjectToArray(state.tags).filter((sector) => (sector.fk == 24));
            $.each(state.elements, (i,item) => {
                let search_by_tags = item.tags != undefined ? match_tag(item.tags) : false;
                if(search_by_tags){
                    if(word_search/* || category_search*/){
                        if(word_search){
                            let match_value = false;
                            item_value_search.map((value,index) => {
                                if(item[value] != undefined){
                                    match_value =  item[value].toLowerCase().indexOf(word_search) !== -1 ? true : match_value;
                                }
                            })
                            if(match_value){
                                results.push(item);
                            }
                        }/*else if(category_search){
                            let match_value = false;
                            item_value_csearch.map((value,index) => {
                                if(item[value] != undefined){
                                    let check_value = item[value].toLowerCase().replace(re1,'').replace(re2,'');
                                    match_value =  check_value.toLowerCase().indexOf(category_search) !== -1 ? true : match_value;
                                }
                            });
                            if(match_value){
                                results.push(item);
                            }
                        }*/
                    }else{
                        results.push(item);
                    }   
                }else if(word_search != '' && word_search != false){
                    let match_value = false;
                    item_value_search.map((value,index) => {
                        if(item[value] != undefined){
                            match_value =  item[value].toLowerCase().indexOf(word_search) !== -1 ? true : match_value;
                        }
                    });
                   
                    if(match_value && state.selecteds.length == 0){
                        results.push(item);
                    }
                }else if(category_search && word_search === false){
                    let match_value = false;
                    item_value_csearch.map((value,index) => {
                        if(item[value] != undefined){
                            let check_value = item[value].toLowerCase().replace(re1,'').replace(re2,'');
                            match_value =  check_value.indexOf(category_search) !== -1 ? true : match_value;
                        }
                    });
                    if(match_value && state.selecteds.length == 0){
                        results.push(item);
                    }
                }else if(activity_search && word_search === false){
                    let match_value = false;
                    (item.tags).map((jtem,j) => {
                        let found_activity = (_tags_activity).find((sector) => sector.id == jtem);//only one
                        if(found_activity){
                            let search_name = (found_activity.nom).toLowerCase().replace(re1,'').replace(re2,'');
                            if(search_name == activity_search)match_value=true;
                        }
                    })
                    if(match_value){
                        results.push(item);
                    }
                }else if(state.selecteds.length == 0){
                    results.push(item);
                }
            });
            
            if(results.length == 0){
                var tag_by_filter = 0;
                if(word_search){
                    $.each(state.tags, (j,jtem) => {
                        if(jtem.nom.toLowerCase() == word_search){
                            tag_by_filter = jtem.id;
                        }
                    });
                }
                if(tag_by_filter>0){
                    $.each(state.elements, (i,item) => {
                        if(item.labels!=undefined){
                            var labels_to_search = (item.labels).split(',');
                            if(('"'+labels_to_search+'"').indexOf(tag_by_filter)>0){
                                results.push(item);
                            }
                        }
                    });
                }
            }
        }else{
            if(is_filter_integrations){
				if(results.length == 0 && word_search.length == 0){
					$.each(elements, function(i,item){
						if(item.apartat_portada_flg == "1"){
							results.push(item);
						}
					});
				}
			}else{
				if(state.order){
					var limit = 1000000000000;
				}else{
					var limit = 100000009;
				}
				
				$.each(state.elements, (i,item) => {
					results.push(item);
					if(i>=limit-1)return false;
				});
			}
        }

		if(state.order && is_filter_success_cases){
			if(state.order == "date") results.sort((a,b) => {return (a.data < b.data) ? 1 : ((b.data < a.data) ? -1 : 0);} );
			if(state.order == "views") results.sort((a,b) => {return (a.views > b.views) ? 1 : ((b.views > a.views) ? -1 : 0);} );
		}

        dispatch({type:'CHANGE',k:'results',v:results});
        dispatch({type:'CHANGE',k:'loading',v:false});
    }

    let class_form = "form";
    if(is_filter_templates)class_form += ' form-3';
    else if(is_filter_success_cases)class_form += ' form-3';
    else if(is_filter_integrations || is_filter_ideas)class_form += ' form-1';
    else class_form += ' form-2';

    //let search_value = state.search != '' ? state.search : (state.csearch != '' ? state.csearch : '');
    let search_value = state.search != '' ? state.search : '';
    let loaded_search = !state.loading;
    const ordered_tags =  (Object.keys(state.tags))
                            .map(key => state.tags[key])
                            .sort((a, b) => {
                                if (a.nom < b.nom) return -1;
                                if (a.nom > b.nom) return 1;
                                return 0;
                            });
                            console.log(ordered_tags,state.tags)
    return (
        <>
            <form class={class_form}>
                <div class={(!is_filter_integrations && !is_filter_ideas? "whatever split-row" : "")}>
                    {(is_filter_templates || is_filter_ebooks || is_filter_success_cases) && (
                        <>
                            <div class="col form-group">
                                <label for="filter" class="form-label txt-6">{labels['filter_by']}</label>
                                <select id="filter" name="filter" class="form-control form-select">
                                    <option value="">{" -- " +labels['label_option'] + " -- "}</option>
                                    {ordered_tags.map((value, key) => {
                                        let obj = state.tags[value.id];
                                        if(obj.fk != null)return null;
                                        return <option key={obj.id} value={obj.id}>{obj.nom}</option>
                                    })}
                                </select>
                            </div>
                            {(is_filter_templates || is_filter_success_cases) && (
                                <div class="col form-group">
                                    <select id="filter2" name="filter2" class="form-control form-select">
                                        <option value="">{" -- " +labels['label_option'] + " -- "}</option>
                                        {ordered_tags.map((value, key) => {
                                            const obj = state.tags[value.id];
                                            if(obj.fk != state.filter)return null;
                                            const search_selecteds = state.selecteds.find((o) => o.id == obj.id);
                                            if(search_selecteds)return null;
                                            return <option key={obj.id} value={obj.id}>{obj.nom}</option>
                                        })}
                                    </select>
                                </div>
                            )}
                        </>
                    )}
                    <div class="col form-group">
                        <label for="search" class="form-label txt-6">{labels['search']}</label>
                        <input type="text" id="search" name="search" value={search_value} onChange={changeSearch} placeholder={labels['search_placeholder']} class="form-control"/>
                    </div> 

                    {(is_filter_success_cases && false) && (
                        <div class="col form-group">
                            <label for="order" class="form-label txt-6">{labels['order_by']}</label>
                            <select id="order" name="order" class="form-control form-select">
                                <option value="">{" -- " +labels['label_option'] + " -- "}</option>
                                <option value="date">{labels['date']}</option>
                                <option value="views">{labels['visits']}</option>
                            </select>
                        </div>
                    )}
                </div>
            </form>

            

            {(state.selecteds.length>0) && (
                <ul class="inline-lst">
                {(state.selecteds).map((item,i) => {
                    return (
                        <li key={"tag-"+i}>
                            <p href="/" class="btn btn-tag has-ico bg-secondary">
                                <span class="txt">{item.nom}</span> 
                                <a onClick={()=> dispatch({type:'DELETE_TAG',id:item.id})} class="close-tag" role="button"><i class="ico knk-close" aria-hidden="true"></i><span class="visually-hidden">Eliminar filtre</span></a>
                            </p>
                        </li>
                    )
                })}
                </ul>
            )}

            {(loaded_search && (state.selecteds.length>0 || state.search || state.csearch || state.asearch || state.order)) && (
                <>
                   {(state.menu.length>0) && (
                        <ul class="list inline-lst">
                            {(state.menu).map((item,i) => {
                                return (
                                    <li key={"menu-"+i}>
                                        <a href={item.url} class={"btn btn-tag"+item.class} role="button">{item.title}</a>
                                    </li>
                                )
                            })}
                        </ul>
                    )}

                    {(state.results.length > 0) ? (
                        <>
                            {(is_filter_templates || is_filter_integrations || is_filter_ebooks || is_filter_ideas || is_filter_success_cases) && (
                                <div class="content-block">
                                    <ul class="grid-col-4 mb-5">
                                        {(state.results).map((element,index) => {
                                            let is_lazy = index > 3 ? true : false;

                                            if(is_filter_integrations){
                                                return (
                                                    <li class="card card-hover wrap-link" key={'element'+index}>
                                                        {(element.apartat_gratis_flg) && (
                                                            <div class="card-ribbon"><span class="txt-8 txt-center w-700 clr-gray">{labels['via_zapier']}</span></div>
                                                        )}
                                                        <div class="card-header">
                                                            <div class="card-icon">
                                                                <span class={"ico " + element.apartat_knk} aria-hidden="true"></span>
                                                            </div>
                                                        </div>
                                                        <div class="card-content txt-center">
                                                            <h3 class="txt-7 w-700 mt-3">
                                                                {(element.url) ? (
                                                                    <a href={element.url} _target={element.target} class="clr-primary">{element.apartat_nom}</a>
                                                                ): (
                                                                    <>{element.apartat_nom}</>
                                                                )}
                                                            </h3> 
                                                            <p class="title txt-7 w-400">{element.apartat_resum}</p>
                                                        </div>
                                                    </li>
                                                )
                                            }

                                            if(is_filter_ebooks){
                                                return (
                                                    <li key={'element'+index}>
                                                    <div class="card wrap-link">
                                                        <div class="card-header">
                                                            <figure class="card-pic">
                                                                <img src={element.image} alt={element.nom} loading={is_lazy ? "lazy" : ""}/>
                                                            </figure>
                                                            <div class="card-action">
                                                                <span class="btn btn-s bg-secondary mt-3" data-href={element.link} onClick={element.ga ? () => gaEvent('send','event','ebook_web','click',element.ga) : null}>{element.nom_button}</span>
                                                            </div>
                                                        </div>
                                                        <div class="card-content">
                                                            <div class="txt-7 w-700 clr-primary mb-2">{element.human_data}</div> 
                                                            <h2 class="title txt-7 w-400">
                                                                <a href={element.link} class="clr-dark" onClick={element.ga ? () => gaEvent('send','event','ebook_web','click',element.ga) : null} rel={element.nofollow ? "nofollow":""}>{element.nom}</a> 
                                                            </h2>
                                                        </div>
                                                    </div>
                                                    </li>
                                                )
                                            }

                                            if(is_filter_ideas){
                                                return (
                                                    <li key={'element'+index}>
                                                    <div class="card wrap-link">
                                                        <div class="card-header">
                                                            <figure class="card-pic">
                                                                <img src={element.image} alt={element.campanya} loading={is_lazy ? "lazy" : ""}/>
                                                            </figure>
                                                            <div class="card-action">
                                                                <p class="text txt-7 clr-inverse">{element.nom}</p>
                                                                <span class="btn btn-s bg-secondary mt-3" data-href={element.link} onClick={element.ga ? () => gaEvent('send','event','ideas_web','click',element.ga) : null}>{labels.see_campaign}</span>
                                                            </div>
                                                        </div>
                                                        <div class="card-content">
                                                            <h2 class="title txt-7 w-400">
                                                                <a href={element.link} class="clr-dark" onClick={element.ga ? () => gaEvent('send','event','ideas_web','click',element.ga) : null} rel={element.nofollow ? "nofollow":""}>{element.campanya}</a> 
                                                            </h2>
                                                        </div>
                                                    </div>
                                                    </li>
                                                )
                                            }

                                            if(is_filter_templates){
                                                return (
                                                    <li key={'element'+index}>   
                                                        <div class={"card " + element.class_element}>
                                                            <div class="card-header">
                                                                <figure class="card-pic">
                                                                    <img src={element.img} loading={is_lazy ? "lazy" : ""} width="100%" height="100%" alt={element.nom} />
                                                                </figure>
                                                                <div class="category has-app-bg clr-inverse">
                                                                    <i class={"ico "+element.promo_type_icon} aria-hidden="true"></i>
                                                                    <p class="txt-7">{element.promo_type_name}</p>
                                                                </div>
                                                                <div class="card-action">
                                                                    {(element.target_link != '') ? (
                                                                        <span onClick={element.ga ? () => gaEvent('send','event','template_web','click',element.ga) : null} class="btn btn-s bg-secondary mt-3" data-href-blank={element.link_button}>{element.label_button}</span>
                                                                    ): (
                                                                        <span onClick={element.ga ? () => gaEvent('send','event','template_web','click',element.ga) : null} class="btn btn-s bg-secondary mt-3" data-href={element.link_button}>{element.label_button}</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div class="card-content">
                                                                <h3 class="title txt-7 w-400">
                                                                    <a onClick={element.ga ? () => gaEvent('send','event','template_web','click',element.ga) : null} href={element.link_button} class="clr-dark" rel={element.nofollow ? "nofollow":""} target={element.target_link != '' ? "_blank":"_self"}>{element.nom}</a> 
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            }

                                            if(is_filter_success_cases){
                                                return (
                                                    <li key={'element'+index}>   
                                                        <div class={"card"}>
                                                            <div class="card-header">
                                                                <figure class="card-pic">
                                                                    <img src={element.img} loading={is_lazy ? "lazy" : ""} width="100%" height="100%" alt={element.nom} />
                                                                </figure>
                                                                <div class="card-action">
                                                                    <span onClick={element.ga ? () => gaEvent('send','event','cases_web','click',element.ga) : null} class="btn btn-s bg-secondary mt-3" data-href={element.link}>{labels['view_case']}</span>
                                                                </div>
                                                            </div>
                                                            <div class="card-content">
                                                                <div class="txt-7 w-700 clr-primary mb-2">{element.data}</div> 
                                                                <h3 class="title txt-7 w-400">
                                                                    <a onClick={element.ga ? () => gaEvent('send','event','cases_web','click',element.ga) : null} href={element.link} class="clr-dark" target={element.target_flg ? '_blank' : '_self'} rel={element.nofollow ? "nofollow":""}>{element.nom}</a> 
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            }
                                        })}
                                    </ul>
                                </div>                            
                            )}
                        </>
                    ) : (
                        <p>{labels['no_results']}</p>
                    )}
                </>
            )}

        </>
    )
}

export default Filters;